import React from 'react';
import './Spinner.scss';

const Spinner = () => <div className="spinner" />;

export default Spinner;
